"use strict";
/*
 * Created on 29. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var ReleaseActionFeasibility_1 = require("../model/ReleaseActionFeasibility");

var ReleaseActionFeasibilityConverter_1 = require("./ReleaseActionFeasibilityConverter");
/**
 * Default implementation of {@link ReleaseActionFeasibilityConverter}
 *
 * @author Radek Beran
 */


var ReleaseActionFeasibilityConverterImpl =
/*#__PURE__*/
function (_ReleaseActionFeasibi) {
  _inherits(ReleaseActionFeasibilityConverterImpl, _ReleaseActionFeasibi);

  function ReleaseActionFeasibilityConverterImpl(userInfoConverter) {
    var _this;

    _classCallCheck(this, ReleaseActionFeasibilityConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseActionFeasibilityConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ReleaseActionFeasibilityConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ReleaseActionFeasibility_1.ReleaseActionFeasibility(ReleaseActionFeasibility_1.ReleaseActionFeasibility.schema.action.valueOfField(source), ReleaseActionFeasibility_1.ReleaseActionFeasibility.schema.allowed.valueOfField(source), ReleaseActionFeasibility_1.ReleaseActionFeasibility.schema.lockedBy.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, {
        action: source.action.toString()
      }); // calling toString on string type enum is not needed

      Object.assign(result, {
        allowed: source.allowed
      });
      Object.assign(result, {
        lockedBy: source.lockedBy !== null ? this.userInfoConverter.toDocument(source.lockedBy, conversions) : null
      });
      return result;
    }
  }]);

  return ReleaseActionFeasibilityConverterImpl;
}(ReleaseActionFeasibilityConverter_1.ReleaseActionFeasibilityConverter);

ReleaseActionFeasibilityConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter])], ReleaseActionFeasibilityConverterImpl);
exports.ReleaseActionFeasibilityConverterImpl = ReleaseActionFeasibilityConverterImpl;